
export default {
    name: 'show-stock',
    components: {},
    props: [],
    data() {
        return {
            liste_entres: ['article', 'initial', 'nombre', 'fournisseur', 'date_peremption', 'date'],
            liste_sorties: ['article', 'motif', 'initial', 'nombre', 'date'],
            liste_echanges: ['type', 'stock', 'article', 'nombre', 'date'],

            disponible: ['libelle', 'quantite']
        }
    },
    computed: {
        stock() {
            return this.$store.getters['stock']
        },

        echanges() {
            return this.$store.getters['echanges']
        },
    },
    mounted() {
        this.$store.dispatch("getStock", this.$route.params.id);
        this.$store.dispatch("getEchanges", this.$route.params.id);

    },
    methods: {

    }
}


